const baseStyle = {
  button: {
    bg: 'white',
    hoverBg: 'white',
    activeBg: 'white',
  },
}

const defaultProps = {
  size: 'lg',
  variant: 'outlined',
}

const parts = ['container', 'button', 'content', 'group', 'option', 'label']

const sizes = {
  sm: {
    button: {
      size: 'sm',
      fontSize: 'sm',
    },
    group: {
      size: 'md',
    },
    option: {
      size: 'md',
    },
    label: {
      fontSize: 'sm',
    },
  },
  md: {
    button: {
      size: 'md',
      fontSize: 'md',
    },
    group: {
      size: 'lg',
    },
    option: {
      size: 'lg',
    },
    label: {
      fontSize: 'md',
    },
  },
  lg: {
    button: {
      size: 'lg',
      fontSize: 'md',
    },
    group: {
      size: 'lg',
    },
    option: {
      size: 'lg',
    },
    label: {
      fontSize: 'md',
    },
  },
  xl: {
    button: {
      size: 'xl',
      fontSize: 'lg',
    },
    group: {
      size: 'xl',
    },
    option: {
      size: 'xl',
    },
    label: {
      fontSize: 'md',
    },
  },
}

const variants = {
  outlined: {
    button: {
      borderColor: 'sandstone.60',
      hoverBorderColor: 'sandstone.60',
    },
  },
  text: {
    button: {
      borderColor: 'transparent',
      hoverBorderColor: 'transparent',
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
